import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { t } from "@i18n";
import type { ReactElement } from "react";
import type { TranslatedString } from "@Helpers/types/i18n";

interface BulkUpdateRolesModalProps {
  headerText: TranslatedString | ReactElement;
  closeModal: () => void;
  modalState: boolean;
  confirmClick: () => void | Promise<void>;
  confirmEnabled: boolean;
  modalContent: () => ReactElement;
}

function BulkUpdateRolesModal({
  headerText,
  closeModal,
  modalState,
  confirmClick,
  confirmEnabled,
  modalContent,
}: BulkUpdateRolesModalProps) {
  return (
    <ModalStateDialogComponent
      allowModalPadding={false}
      width="60%"
      onCancel={() => closeModal()}
      headerTitle={headerText}
      modelContent={modalContent()}
      footerContent={
        <div className="flex gap-[1.375rem] px-10 pb-7 pt-4">
          <ButtonComponent buttonType={BUTTON_TYPES.GRADIENT_BUTTON} onClick={confirmClick} disabled={!confirmEnabled}>
            {t("Confirm")}
          </ButtonComponent>
          <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeModal}>
            {t("Discard")}
          </ButtonComponent>
        </div>
      }
      isVisible={modalState}
    />
  );
}

export default BulkUpdateRolesModal;
